import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OverviewVm } from 'app/shared/generated/Dashboard/Models/OverviewVm';

@Injectable({
    providedIn: 'root',
})
export class LandingService {
    constructor(private httpClient: HttpClient) {}

    getOverviewVm(): Observable<OverviewVm> {
        return this.httpClient.get<OverviewVm>('api/Dashboard/GetOverviewVm');
    }
}
